import { render, staticRenderFns } from "./dialog-select.vue?vue&type=template&id=5103aac2&"
import script from "./dialog-select.vue?vue&type=script&lang=js&"
export * from "./dialog-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports